import React from "react";
import TimePicker from "../../../ui-library/DateAndTime/TimePicker/TimePicker";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import { timePickerReducer, mapStateToProps } from "./TimePicker.store";

const REACT_DATEPICKER_12H_FORMAT = "h:mm aa";
const REACT_DATEPICKER_24H_FORMAT = "HH:mm";
const INPUT_TIMEPICKER_12H_FORMAT = "h:mm A";
const INPUT_TIMEPICKER_24H_FORMAT = "HH:mm";

export const SmartTimePicker = (props) => {
  const { timeFormat = "12h", participantTimeFormat, ...other } = props;

  console.log("TimePicker props", timeFormat, participantTimeFormat);

  const getTimeFormatForPicker = (format) => {
    switch (format) {
      case "24h":
        return {
          reactDatePickerFormat: REACT_DATEPICKER_24H_FORMAT,
          inputTimePickerFormat: INPUT_TIMEPICKER_24H_FORMAT,
        };
      default:
        return {
          reactDatePickerFormat: REACT_DATEPICKER_12H_FORMAT,
          inputTimePickerFormat: INPUT_TIMEPICKER_12H_FORMAT,
        };
    }
  };

  return (
    <TimePicker
      {...other}
      datePickerTimeFormat={
        getTimeFormatForPicker(participantTimeFormat || timeFormat)
          .reactDatePickerFormat
      }
      datePickerInputTimeFormat={
        getTimeFormatForPicker(participantTimeFormat || timeFormat)
          .inputTimePickerFormat
      }
    />
  );
};

export default dynamic(
  "timePickerReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state, rootState) => {
      if (!state.smartPageHeaderReducer) {
        return {
          ...state,
          smartPageHeaderReducer: rootState.smartPageHeaderReducer,
        };
      }

      return state;
    },
  }),
  attachReducer(timePickerReducer)
)(connect(mapStateToProps)(SmartTimePicker));
